export default "__VITE_ASSET__DXj9VdZn__"